<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card">
	<div class="card-header bg-theme">
		<h5 class="card-title pt-1 text-light mb-0">
			Chat with candidate
		</h5>
	</div>
	<div class="card-body">
		<form (ngSubmit)="sendMsg('',msg)" (keydown)="keyDownFunction($event)" class="form-container">
			<div class="chatBoxScroll">
				<div *ngFor="let item of messages;let i = index;">
					<div class="col-sm-12 pl0 mt-1">
						<label
							[ngClass]="{'float-end chat-sender' : item.from=='me', 'float-start chat-receiver' : item.from!='me'}"
							class="control-label">
							<small class="timeStyle">{{item.from}}:</small>
							@if (!item.imageUrl) {
							<a *ngIf="validURL(item.text)" href="{{item.text}}" target="_blank">
								{{item.text}}
							</a>
							<ng-container *ngIf="!validURL(item.text)">
								{{item.text}}
							</ng-container>
							}@else {
							<a href="{{item.imageUrl}}" target="_blank">
								<fa-icon [icon]="['fas', 'file']" size="2x"></fa-icon>
								<p style="overflow-x: clip;">{{clipText(item.text,20)}}</p>
							</a>
							}
							<br>
							<!-- <small class="timeStyle">{{item.msgTime.seconds * 1000 | date:'dd-MM-yyyy h:mm a'}}</small> -->
						</label>
					</div>
				</div>
			</div>
			<textarea placeholder="Type message.." [(ngModel)]="msg" [ngModelOptions]="{standalone: true}"></textarea>
			<button type="submit" [disabled]="!msg?true:null" class="btn btn-success btn-sm">
				Send
			</button>
			<!--  <fa-icon (click)="openFileMang()" matTooltip="Attach File" role="button" [icon]="['fas', 'paperclip']"
				size="2x" class="ms-1">
			</fa-icon> -->
		</form>
	</div>
</div>
<div class="modal fade" id="chatFileModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"><strong>File Upload</strong></h4>
				<fa-icon *ngIf="fileUploaderLoader" [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="caseFilesUpload($event)">
					<ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
						<div style="text-align: center;">
							<label>*Drop files here</label><br>
							<label>OR</label><br>
							<button type="button" class="btn btn-primary btn-sm" (click)="openFileSelector()">Browse
								Files</button>
						</div>
					</ng-template>
				</ngx-file-drop>
			</div>
			<div class="modal-footer">
			</div>
		</div>
	</div>
</div>